<template>
  <div>
    <v-row>

      <v-col
        cols="6"
        sm="6"
        md="6"
      >
        <v-card-text class="pa-0">
          <div class="overline">Status</div>
          <div class="body-1">{{ stateName }}</div>
        </v-card-text>
      </v-col>

      <v-col
        cols="6"
        sm="6"
        md="6"
      >
        <template v-if="selectedApplication.region">
          <div class="overline">BYN-REGION</div>
          <div class="body-1">{{ selectedApplication.region.name }}</div>
        </template>
      </v-col>

    </v-row>
    <v-btn
      color="secondary"
      @click="showProcessModal"
      class="mb-2"
    >
      <v-icon>$sl-info</v-icon>VISA VAR I PROCESSEN ANMÄLAN BEFINNER SIG
    </v-btn>

    <ApplicationInfoModal
      @close="showInfo = !showInfo"
      :showInfo="showInfo"
      :application="{...selectedApplication, company: applicationCompany}"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {ApplicationModal} from '@/components/mixins'
import ApplicationInfoModal from '@/components/application/ApplicationInfoModal'

export default {
  name: 'ApplicationStatusView',

  mixins: [ApplicationModal],

  props: {
    stateName: {
      type: String,
      default: ''
    }
  },

  components: {
    ApplicationInfoModal
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'applicationCompany'])
  }
}
</script>

<style lang="scss" scoped>
</style>